import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NoteTagUserResult } from 'src/app/job/models/job-detail/Notes/notes.result.model';
import { EnvelopeResponse } from 'src/app/shared/models/envelope-response';
import { SearchPropertiesByAddressResult } from 'src/app/shared/models/search-property-by-address-result.model';
import { BaseService } from '../base/base.service';
import { PropertySearchResult } from 'src/app/asset/models/property-search-result.model';

@Injectable({
  providedIn: 'root',
})
export class PropertySearchService extends BaseService {
  private agencyManagementBaseUrl = '/agencymgmt/api/property/';
  constructor(http: HttpClient) {
    super(http);
  }

  searchPropertiesByAddress(FractionOfAddress: string) {
    return this.get<SearchPropertiesByAddressResult[]>(
      this.agencyManagementBaseUrl +
        'search-by-address?FractionOfAddress=' +
        FractionOfAddress
    );
  }

  getPropertyUsersForNoteTags(propertyId: string, searchTerm: string) {
    const queryParams = this.queryParams({
      propertyId,
      searchTerm,
    });
    return this.get<NoteTagUserResult[]>(
      `${this.agencyManagementBaseUrl}search-tagable-property-user${queryParams}`
    );
  }

  searchProperties(searchKey: string) {
    return this.get<PropertySearchResult[]>(  `${this.agencyManagementBaseUrl}search?SearchKey=${searchKey}`);
  }
}
